import { format } from 'date-fns';

export const timeFormatter = (time: Date) => format(time, 'hh:mm a');
